export default __webpack_public_path__ + "static/media/p3-17.2141d750.png";